import React, { useEffect, useState } from "react";

import facebook from "../assets/images/facebook.svg";
import instagram from "../assets/images/instagram.svg";
import Snapchat from "../assets/images/Snapchat.svg";
import tiktokblack from "../assets/images/tiktok-black.svg";
import gmailicon from "../assets/images/mail_icon.svg";
import locationicon from "../assets/images/location-icon.svg";
import iconloction from "../assets/images/icon-location.svg";
import callicon from "../assets/images/call-icon.svg";
import foodhygiene from "../assets/images/food-hygiene.svg";
import ordericon from "../assets/images/order_icon.svg";
import "swiper/css";
import { Link, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import sumologo from "../assets/images/sumo_logo.png";
import { HomeActions } from "../_actions/homeContent.action";
import { useDispatch, useSelector } from "react-redux";
import { status } from "../_constants";
import { config } from "../config";

import { CCol, CRow } from "@coreui/react";
import { CDatePicker } from "@coreui/react-pro";
import "@coreui/coreui-pro/dist/css/coreui.min.css";
// import "./ReservationForm.css";
import { alert } from "../_utilities";
import CustomLoader from "./CustomeLoader";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { forwardRef } from "react";
import HomeFooter from "./HomeFooter";

function Bombay_Spice_Reservation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const home = useSelector((state) => state.home);
  const configData = JSON.parse(localStorage.getItem("configData"));

  const [homeData, sethomeData] = useState();
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isValidate, setIsValidate] = useState(false);
  const [TimingSlotData, setTimingSlotData] = useState({});
  const [closedDateRanges, setClosedDateRanges] = useState([]);
  // const today = new Date().toISOString().split("T")[0];

  const today = new Date().toISOString().split("T")[0];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    date: today,
    time: "",
    people: "",
  });

  // console.log("formData.date", formData.date);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchClosedDays = async () => {
    let response = await fetch(
      `${config.localApiUrl}/api/reservation/closed-days`,
    );

    response = await response.json();
    // console.log("71 Closed Days Response:", response);

    if (response.success && response.data.length > 0) {
      const formatted = response.data.map((range) => {
        const [startY, startM, startD] = range.start_date.split("-");
        const [endY, endM, endD] = range.end_date.split("-");
        // console.log(77, { startY, startM, startD, endY, endM, endD });

        return {
          start: new Date(startY, startM - 1, startD),
          end: new Date(endY, endM - 1, endD),
        };
      });
      // console.log("84 Formatted Closed Date Ranges:", formatted);
      setClosedDateRanges(formatted);
    }
  };

  const fetchDataForTimeSlot = async () => {
    let result = await fetch(`${config.localApiUrl}/api/reservation/timings`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    result = await result.json();
    if (result.status == 200) {
      setTimingSlotData(result.data);
    }
  };

  useEffect(() => {
    if (configData?.allowBooking == false) {
      navigate("/");
    }
    if (!home?.homeContent_data) {
      dispatch(HomeActions.loadHomeData());
    }
    fetchDataForTimeSlot();
    fetchClosedDays();
  }, []);

  const preloadImages = (imageUrls) => {
    return imageUrls.map((url) => {
      const img = new Image();
      img.src = url;
    });
  };

  useEffect(() => {
    if (home && home?.homeContent_status == status?.SUCCESS) {
      sethomeData(home?.homeContent_data);
      localStorage.setItem("home", JSON.stringify(home?.homeContent_data));
      const imageUrls = [
        `${config.localApiUrl}/tenancy/assets/${home?.homeContent_data?.banners[0]?.banner}`,
        `${config.localApiUrl}/tenancy/assets/${home?.homeContent_data?.banners[1]?.banner}`,
      ];
      preloadImages(imageUrls);
      setLoading(false);
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [home?.homeContent_data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const handleDateChange = (dateObj) => {
  //   if (!dateObj) return;
  //   const formatted = dateObj.toISOString().split("T")[0];
  //   setFormData((prev) => ({ ...prev, date: formatted }));
  // };

  const handleDateChange = (dateObj) => {
    if (!dateObj) return;
    const formatted = dateObj.toISOString().split("T")[0];

    const selectedDate = new Date(formatted);
    const today = new Date();
    const isToday =
      selectedDate.getFullYear() === today.getFullYear() &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getDate() === today.getDate();

    // console.log("133 selectedDate", selectedDate);

    let autoTime = "";
    if (isToday) {
      const slots = getFilteredSlots();
      if (slots.length > 0) autoTime = slots[0];
    }
    setFormData((prev) => ({
      ...prev,
      date: formatted,
      time: autoTime,
    }));
    // console.log("140 formatted", formatted);
  };

  const formatDateToDDMMYYYY = (dateStr) => {
    const [yyyy, mm, dd] = dateStr.split("-");
    return `${dd}/${mm}/${yyyy}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsValidate(true);
    const errorData = validateForm(true);
    if (errorData && errorData.isValid) {
      setIsValidate(false);
      setIsLoading(true);
      const { name, email, phone, date, time, people, message } = formData;

      const data = {
        date: date,
        time: time,
        number_of_people: people,
        name: name,
        phone: phone,
        email: email,
        message: message,
      };

      let response = await fetch(`${config.localApiUrl}/api/booking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      response = await response.json();
      if (response.status == 200) {
        alert.success("Thank you! Your booking has been placed.");
        setTimeout(() => {
          setIsLoading(false);
          navigate("/");
        }, 500);

        if (
          Object.keys(TimingSlotData).length > 0 &&
          TimingSlotData.allow_booking_whatsapp_share === "true"
        ) {
          const messageData =
            `*Reservation Booking Request!*\n\n` +
            `Name: ${name}\n` +
            `Email: ${email}\n` +
            `Time: ${time}\n` +
            `Date: ${formatDateToDDMMYYYY(date)}\n` +
            `Phone: ${phone}\n` +
            `Number of People: ${people}\n\n` +
            `Message: ${message}`;

          const encodedMessage = encodeURIComponent(messageData);
          const phoneNumber = TimingSlotData.booking_whatsapp_number;
          const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
          window.open(whatsappURL, "_blank");
        }
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
          date: null,
          time: "",
          people: "",
        });
      } else {
        alert.error(response.message);
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
          date: null,
          time: "",
          people: "",
        });
        setIsLoading(false);
      }
    }
  };

  const validateForm = (isValidate) => {
    const validObj = {
      message: "",
      isValid: true,
    };
    let isValid = true;
    const retData = {
      name: validObj,
      email: validObj,
      phone: validObj,
      message: validObj,
      date: validObj,
      time: validObj,
      people: validObj,
    };

    if (isValidate) {
      const { name, email, phone, message, date, time, people } = formData;

      if (!name) {
        retData.name = {
          message: "Name is required",
          isValid: false,
        };
        isValid = false;
      }

      if (!email) {
        retData.email = {
          message: "Email is required",
          isValid: false,
        };
        isValid = false;
      } else if (!/^\S+@\S+\.\S+$/.test(email)) {
        retData.email = {
          message: "Enter a valid email",
          isValid: false,
        };
        isValid = false;
      }

      if (!phone) {
        retData.phone = {
          message: "Phone number is required",
          isValid: false,
        };
        isValid = false;
      } else if (!/^\d{11}$/.test(phone)) {
        retData.phone = {
          message: "Enter a valid 11-digit phone number",
          isValid: false,
        };
        isValid = false;
      }

      if (!date) {
        retData.date = {
          message: "Date is required",
          isValid: false,
        };
        isValid = false;
      }

      if (!time) {
        retData.time = {
          message: "Time is required",
          isValid: false,
        };
        isValid = false;
      }

      if (!people) {
        retData.people = {
          message: "Number of people is required",
          isValid: false,
        };
        isValid = false;
      }

      if (message.length > 200) {
        retData.message = {
          message: "Message should be less than 200 characters",
          isValid: false,
        };
        isValid = false;
      }

      retData.isValid = isValid;
      return retData;
    }
  };

  function convertDateToString(dateObj) {
    if (dateObj && !isNaN(dateObj)) {
      let month = (dateObj.getMonth() + 1).toString();
      month = month.length === 1 ? "0" + month : month;
      let date = dateObj.getDate().toString();
      date = date.length === 1 ? "0" + date : date;
      let year = dateObj.getFullYear().toString();
      return `${year}-${month}-${date}`;
    }
    return "";
  }

  const getUKTimeParts = () => {
    const now = new Date();
    const ukString = now.toLocaleString("en-GB", {
      timeZone: "Europe/London",
      hour: "numeric",
      minute: "numeric",
      hour12: false,
    });
    // console.log("UK Time String:", ukString);

    const [hour, minute] = ukString.split(":").map(Number);
    // console.log("UK Time Parts:", { hour, minute });

    return { hour, minute };
  };
  const getFilteredSlots = () => {
    if (!TimingSlotData?.timings_by_day) return [];
    // console.log(373,TimingSlotData);

    const selectedDate = new Date(formData.date);
    const dayName = selectedDate
      .toLocaleDateString("en-GB", { weekday: "long" })
      .toLowerCase();

    const dayData = TimingSlotData.timings_by_day[dayName];

    if (!dayData || !dayData.enabled) return [];

    let slots = dayData.slots || [];

    const today = new Date();
    const isToday =
      selectedDate.getFullYear() === today.getFullYear() &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getDate() === today.getDate();

    // console.log(392, { isToday, selectedDate, today });
    // console.log("393 slots", slots);
    // console.log("394 TimingSlotData", TimingSlotData);

    if (!isToday) return slots;

    const { hour: currentHour, minute: currentMinute } = getUKTimeParts();

    return slots.filter((slot) => {
      const [time, modifier] = slot.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      if (hours > currentHour) return true;
      if (hours === currentHour && minutes > currentMinute) return true;

      return false;
    });
  };
  const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
    <input
      type="text"
      readOnly
      ref={ref}
      onClick={onClick}
      value={value}
      placeholder="Select Date"
      className="reservation-input calendar-icon"
    />
  ));

  const errorData = validateForm(isValidate);

  return (
    <>
      {isLoading ? (
        <CustomLoader loading={isLoading} />
      ) : (
        <div className="home-page home-page2 list-store-section reservation-form">
          <div className="reservation-container">
            <h2 className="reservation-title">MAKE RESERVATION</h2>
            <p className="reservation-subtitle">
              We will confirm your booking by email. Thank you.
            </p>
            <form className="reservation-form" onSubmit={handleSubmit}>
              {/* <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleDateChange}
                className="reservation-input"
                dateFormat="dd/MM/yyyy"
                min={convertDateToString(new Date())}
                max={convertDateToString(
                  new Date(
                    Date.now() +
                    Number(TimingSlotData.booking_days_allowed) *
                    24 *
                    60 *
                    60 *
                    1000
                  )
                )}
              /> */}
              <DatePicker
                selected={formData.date ? new Date(formData.date) : new Date()}
                onChange={handleDateChange}
                minDate={new Date(new Date().setHours(0, 0, 0, 0))}
                maxDate={
                  new Date(
                    Date.now() +
                      Number(TimingSlotData.booking_days_allowed) *
                        24 *
                        60 *
                        60 *
                        1000,
                  )
                }
                excludeDateIntervals={closedDateRanges}
                filterDate={(date) => {
                  // If timings data hasn't loaded yet, allow all dates
                  if (!TimingSlotData?.timings_by_day) return true;

                  // Get the day name (e.g., "tuesday", "wednesday")
                  const dayName = date
                    .toLocaleDateString("en-GB", { weekday: "long" })
                    .toLowerCase();

                  const dayData = TimingSlotData.timings_by_day[dayName];

                  // Only allow dates where the day is enabled
                  return dayData?.enabled === true;
                }}
                dateFormat="d-MM-yyyy"
                customInput={<CustomDateInput />}
              />
              {errorData && errorData.date.message != "" && (
                <span>{errorData.date.message}</span>
              )}
              {/* <select
                className="reservation-input time-select"
                name="time"
                value={formData.time}
                onChange={handleChange}
              >
                <option value="">Pick a Time</option>
                {TimingSlotData &&
                  Object.keys(TimingSlotData).length > 0 &&
                  TimingSlotData.slots &&
                  TimingSlotData.slots.length > 0 &&
                  TimingSlotData.slots.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
              </select> */}
              <select
                className="reservation-input time-select"
                name="time"
                value={formData.time}
                onChange={handleChange}
              >
                <option value="">Pick a Time</option>
                {getFilteredSlots().map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </select>
              {errorData && errorData.time.message != "" && (
                <span>{errorData.time.message}</span>
              )}
              <select
                className="reservation-input people-select"
                name="people"
                value={formData.people}
                onChange={handleChange}
              >
                <option value="">Number of People</option>
                {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
                <option value="10+">10+</option>
              </select>
              {errorData && errorData.people.message != "" && (
                <span>{errorData.people.message}</span>
              )}
              <input
                type="text"
                name="name"
                placeholder="Name"
                className="reservation-input"
                onChange={handleChange}
              />
              {errorData && errorData.name.message != "" && (
                <span>{errorData.name.message}</span>
              )}
              <input
                type="email"
                name="email"
                placeholder="Email"
                className="reservation-input"
                onChange={handleChange}
              />{" "}
              {errorData && errorData.email.message != "" && (
                <span>{errorData.email.message}</span>
              )}
              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                className="reservation-input"
                onChange={handleChange}
                minLength={11}
                maxLength={11}
              />{" "}
              {errorData && errorData.phone.message != "" && (
                <span>{errorData.phone.message}</span>
              )}
              <textarea
                name="message"
                placeholder="Message..."
                className="reservation-textarea"
                onChange={handleChange}
              />
              {errorData && errorData.message.message != "" && (
                <span>{errorData.message.message}</span>
              )}
              <button type="submit" className="reservation-button">
                Submit
              </button>
            </form>
          </div>
          <HomeFooter />
          {/* <div className="home-footer home-footer-2">
            <div className="container">
              <div className="row-nowrap">
                <div className="content">
                  {loading ? (
                    <Skeleton
                      width={"100%"}
                      height={30}
                      baseColor="#4f4e4e"
                      highlightColor="#eeeeee33"
                      borderRadius={20}
                      style={{ marginTop: 70 }}
                    />
                  ) : (
                    // <img src={homefooterlogo} alt="" className="logo-footer" />
                    <Link to="/">
                      <img
                        src={
                          configData &&
                          `${config.localApiUrl}/tenancy/assets/${configData.headerLogo}`
                        }
                        alt=""
                        className="logo-footer"
                      />
                    </Link>
                  )}
                </div>
                <div className="content">
                  <h3>
                    {loading ? (
                      <Skeleton
                        width={"100%"}
                        height={25}
                        baseColor="#4f4e4e"
                        highlightColor="#eeeeee33"
                        borderRadius={20}
                      />
                    ) : (
                      "Location"
                    )}
                  </h3>
                  {loading ? (
                    <Skeleton
                      width={"100%"}
                      height={18}
                      baseColor="#4f4e4e"
                      highlightColor="#eeeeee33"
                      borderRadius={20}
                    />
                  ) : (
                    <p>{homeData && homeData.locationData.addressLine1}</p>
                  )}
                  {loading ? (
                    <Skeleton
                      width={"100%"}
                      height={18}
                      baseColor="#4f4e4e"
                      highlightColor="#eeeeee33"
                      borderRadius={20}
                    />
                  ) : (
                    <p>{homeData && homeData.locationData.addressLine2}</p>
                  )}
                  {loading ? (
                    <Skeleton
                      width={"100%"}
                      height={45}
                      baseColor="#4f4e4e"
                      highlightColor="#eeeeee33"
                      borderRadius={30}
                      style={{ marginTop: 20 }}
                    />
                  ) : (
                    <div className="get-btn">
                      <a
                        href={homeData && homeData.locationData.directionLink}
                        target="_blank"
                      >
                        <img src={iconloction} alt="" />
                        <span>Get Directions</span>
                      </a>
                    </div>
                  )}
                </div>
                <div className="content">
                  <h3>
                    {loading ? (
                      <Skeleton
                        width={"100%"}
                        height={25}
                        baseColor="#4f4e4e"
                        highlightColor="#eeeeee33"
                        borderRadius={20}
                      />
                    ) : (
                      "Opening hours"
                    )}
                  </h3>
                  <div className="opening">
                    <div className="time">
                      <p>
                        {loading ? (
                          <Skeleton
                            width={100}
                            height={18}
                            baseColor="#4f4e4e"
                            highlightColor="#eeeeee33"
                            borderRadius={20}
                          />
                        ) : (
                          "Mon to Fri"
                        )}
                      </p>
                      <span>
                        {loading ? (
                          <Skeleton
                            width={50}
                            height={18}
                            baseColor="#4f4e4e"
                            highlightColor="#eeeeee33"
                            borderRadius={20}
                          />
                        ) : homeData && homeData.openingHoursData.Weekdays ? (
                          homeData.openingHoursData.Weekdays
                        ) : (
                          `${homeData &&
                          homeData.openingHoursData &&
                          homeData.openingHoursData.Monday
                          }`
                        )}
                      </span>
                    </div>

                    <div className="time">
                      <p>
                        {loading ? (
                          <Skeleton
                            width={100}
                            height={18}
                            baseColor="#4f4e4e"
                            highlightColor="#eeeeee33"
                            borderRadius={20}
                          />
                        ) : (
                          "Saturday"
                        )}
                      </p>
                      <span>
                        {loading ? (
                          <Skeleton
                            width={50}
                            height={18}
                            baseColor="#4f4e4e"
                            highlightColor="#eeeeee33"
                            borderRadius={20}
                          />
                        ) : homeData && homeData.openingHoursData.Saturday ? (
                          homeData.openingHoursData.Saturday
                        ) : (
                          `${homeData &&
                          homeData.openingHoursData &&
                          homeData.openingHoursData.Saturday
                          }`
                        )}
                      </span>
                    </div>
                    <div className="time">
                      <p>
                        {loading ? (
                          <Skeleton
                            width={100}
                            height={18}
                            baseColor="#4f4e4e"
                            highlightColor="#eeeeee33"
                            borderRadius={20}
                          />
                        ) : (
                          "Sunday"
                        )}
                      </p>
                      <span>
                        {loading ? (
                          <Skeleton
                            width={50}
                            height={18}
                            baseColor="#4f4e4e"
                            highlightColor="#eeeeee33"
                            borderRadius={20}
                          />
                        ) : homeData && homeData.openingHoursData.Sunday ? (
                          homeData.openingHoursData.Sunday
                        ) : (
                          `${homeData &&
                          homeData.openingHoursData &&
                          homeData.openingHoursData.Sunday
                          }`
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="content">
                  <h3>
                    {loading ? (
                      <Skeleton
                        width={"100%"}
                        height={25}
                        baseColor="#4f4e4e"
                        highlightColor="#eeeeee33"
                        borderRadius={20}
                      />
                    ) : (
                      "Get In Touch"
                    )}
                  </h3>
                  <ul>
                    <li>
                      {loading ? (
                        <Skeleton
                          width={"100%"}
                          height={18}
                          baseColor="#4f4e4e"
                          highlightColor="#eeeeee33"
                          borderRadius={20}
                        />
                      ) : (
                        <a href="tel:0161 620 2150">
                          <img src={callicon} />
                          {homeData && homeData.getintouchData.contactNumber}
                        </a>
                      )}
                    </li>
                    <li>
                      {loading ? (
                        <Skeleton
                          width={"100%"}
                          height={18}
                          baseColor="#4f4e4e"
                          highlightColor="#eeeeee33"
                          borderRadius={20}
                        />
                      ) : (
                        <a href="/">
                          <img src={locationicon} />
                          sumoshawarma.com.uk
                        </a>
                      )}
                    </li>
                    <li>
                      {loading ? (
                        <Skeleton
                          width={"100%"}
                          height={18}
                          baseColor="#4f4e4e"
                          highlightColor="#eeeeee33"
                          borderRadius={20}
                        />
                      ) : (
                        <a
                          href={`mailto:${homeData && homeData.getintouchData.supportEmail
                            }`}
                        >
                          <img src={gmailicon} />
                          {homeData && homeData.getintouchData.supportEmail}
                        </a>
                      )}
                    </li>
                  </ul>
                </div>
                <div className="content">
                  <div className="footer-icon">
                    <ul>
                      <li>
                        {loading ? (
                          <Skeleton
                            width={30}
                            height={30}
                            baseColor="#4f4e4e"
                            highlightColor="#eeeeee33"
                            borderRadius={50}
                          />
                        ) : (
                          <a href="https://www.facebook.com">
                            <img src={facebook} alt="" />
                          </a>
                        )}
                      </li>
                      <li>
                        {loading ? (
                          <Skeleton
                            width={30}
                            height={30}
                            baseColor="#4f4e4e"
                            highlightColor="#eeeeee33"
                            borderRadius={50}
                          />
                        ) : (
                          <a href="https://www.instagram.com">
                            <img src={instagram} alt="" />
                          </a>
                        )}
                      </li>
                      <li>
                        {loading ? (
                          <Skeleton
                            width={30}
                            height={30}
                            baseColor="#4f4e4e"
                            highlightColor="#eeeeee33"
                            borderRadius={50}
                          />
                        ) : (
                          <a href="https://www.Snapchat.com">
                            <img src={Snapchat} alt="" />
                          </a>
                        )}
                      </li>
                      <li>
                        {loading ? (
                          <Skeleton
                            width={30}
                            height={30}
                            baseColor="#4f4e4e"
                            highlightColor="#eeeeee33"
                            borderRadius={50}
                          />
                        ) : (
                          <a href="https://www.tiktok.com">
                            <img src={tiktokblack} alt="" />
                          </a>
                        )}
                      </li>
                    </ul>
                  </div>
                  {loading ? (
                    <Skeleton
                      width={"100%"}
                      height={100}
                      baseColor="#4f4e4e"
                      highlightColor="#eeeeee33"
                      borderRadius={10}
                    />
                  ) : (
                    configData?.starRating ? <img src={foodhygiene} alt="" /> : null
                  )}
                </div>
              </div>
            </div>
          </div> */}
          <div className="home-footer-button">
            <div className="container">
              <ul>
                <li>
                  {loading ? (
                    <Skeleton
                      width={150}
                      height={54}
                      baseColor="#4f4e4e"
                      highlightColor="#eeeeee33"
                      zIndex={9}
                    />
                  ) : (
                    <a href="tel:0161 620 2150">
                      <img src={callicon} alt="" />
                      <a href="tel:0161 620 2150">Call Now</a>
                    </a>
                  )}
                </li>
                <li>
                  {loading ? (
                    <Skeleton
                      width={150}
                      height={54}
                      baseColor="#4f4e4e"
                      highlightColor="#eeeeee33"
                      zIndex={9}
                    />
                  ) : (
                    <a href="/">
                      <img src={ordericon} alt="" />
                      <Link to="/menu">Order Online</Link>
                    </a>
                  )}
                </li>
                {/* <li>
                                    <img src={iconcalendar} alt="" />
                                    <a href="#">Reservation</a>
                                </li> */}
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default Bombay_Spice_Reservation;
